import BottomButtons from "components/buttons/bottomButtons";
import HeadingComponent from "components/headingComponent";
import {
  addDoc,
  and,
  collection,
  doc,
  getDocs,
  or,
  query,
  Timestamp,
  updateDoc,
  where,
} from "firebase/firestore";
import { dbFirestore } from "helper/config/firebase";
import ButtonLabels from "helper/constant/buttonLabels";
import CommonHeadings from "helper/constant/headings";
import VisaRefusalKeys from "helper/constant/visaRefusalKeys";
import { VisaTypeKeys } from "helper/constant/visaType";
import ErrorMessages from "helper/errorMessages";
import RoutingPaths from "helper/routingPath";
import TableName from "helper/tableName/tableName";
import ToastMessages from "helper/toastMessages";
import { Dropdown } from "primereact/dropdown";
import { InputText } from "primereact/inputtext";
import { InputTextarea } from "primereact/inputtextarea";
import React, { useEffect, useLayoutEffect, useState } from "react";
import { useLocation, useNavigate } from "react-router-dom";
import AsyncSelect from "react-select/async";
import { toast, ToastContainer } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";

function Visa() {
  const [isSubmitted, setIsSubmitted] = useState(false);
  const visaRefusalDropdown = [VisaRefusalKeys.key1, VisaRefusalKeys.key2];
  const visaTypeDropdown = [
    VisaTypeKeys.key1,
    VisaTypeKeys.key2,
    VisaTypeKeys.key3,
  ];
  const [visaHeading, setVisaHeading] = useState(CommonHeadings.visaAddHeading);
  const [buttonLabel, setButtonLabel] = useState(ButtonLabels.saveLabel);
  const [loading1, setLoading1] = useState(false);
  const [loading2, setLoading2] = useState(false);
  const [visaID, setVisaID] = useState();
  const location = useLocation();
  const navigate = useNavigate();

  const [visaInfo, setVisaInfo] = useState({
    student_type: null,
    student_firebase_id: null,
    visa_type: "",
    country: "",
    visa_consultant_fee: "",
    visa_Processing_time: "",
    applicant_name: "",
    address: "",
    tenth_marks: "",
    twelfth_marks: "",
    graduation: "",
    other_degree: "",
    selected_course_id: null,
    selected_visa_refusal: "",
    refusal_reason: "",
  });

  const [errors, setErrors] = useState({
    student_type: null,
    student_firebase_id: null,
    visa_type: "",
    country: "",
    visa_consultant_fee: "",
    visa_Processing_time: "",
    applicant_name: "",
    address: "",
  });

  // MARK: Use Effect Method
  useEffect(() => {
    //  edit functionality
    if (location.state) {
      setEditVisaUI();
    }
  }, []); // eslint-disable-line react-hooks/exhaustive-deps

  // MARK: Use Layout Method
  useLayoutEffect(() => {
    document.title = location.state
      ? CommonHeadings.visaEditHeading
      : CommonHeadings.visaAddHeading;
  }, []); // eslint-disable-line react-hooks/exhaustive-deps

  const inputChange = (e) => {
    var { name, value } = e.target;

    setVisaInfo({
      ...visaInfo,
      [name]: value,
    });
  };

  const studentsTypeSelect = (e) => {
    const name = "student_type";
    setVisaInfo({
      ...visaInfo,
      [name]: e,
    });
  };

  const studentsAdmissionSelect = (e) => {
    const name = "student_firebase_id";

    setVisaInfo({
      ...visaInfo,
      [name]: e,
    });

    if (e === null) {
      return;
    }

    setVisaInfo((prevState) => ({
      ...prevState,
      applicant_name: e.name,
    }));
  };

  const courseSelect = (e) => {
    const name = "selected_course_id";

    setVisaInfo({
      ...visaInfo,
      [name]: e,
    });
  };

  const inputDropVisaRefusal = (e) => {
    const { name, value } = e.target;

    setVisaInfo({
      ...visaInfo,
      [name]: value,
    });
  };

  const inputDropVisaType = (e) => {
    const { name, value } = e.target;

    setVisaInfo({
      ...visaInfo,
      [name]: value,
    });
  };

  const validateForm = (data) => {
    const errors = {};
    if (!data.applicant_name) {
      errors.applicant_name = ErrorMessages.name;
    }
    if (!data.address) {
      errors.address = ErrorMessages.address;
    }
    if (!data.student_type) {
      errors.student_type = ErrorMessages.studentType;
    }
    if (!data.visa_type) {
      errors.visa_type = ErrorMessages.visaType;
    }
    if (!data.country) {
      errors.country = ErrorMessages.country;
    }
    if (!data.visa_consultant_fee) {
      errors.visa_consultant_fee = ErrorMessages.visaFee;
    }
    if (!data.visa_Processing_time) {
      errors.visa_Processing_time = ErrorMessages.processtiming;
    }
    if (data.student_type === "existing_student") {
      if (!data.student_firebase_id) {
        errors.student_firebase_id = ErrorMessages.studentId;
      }
    }

    return errors;
  };

  const tapOnSave = () => {
    const newErrors = validateForm(visaInfo);
    setErrors(newErrors);
    setIsSubmitted(true);
    if (Object.keys(newErrors).length === 0) {
      setLoading1(true);
      if (location.state) {
        updateVisaInfoApi();
      } else {
        writeVisaApi();
      }
    }
  };

  // this function is working when we submit the form by clicking on save andnext button
  const tapOnSaveNext = () => {
    const newErrors = validateForm(visaInfo);
    setErrors(newErrors);
    setIsSubmitted(true);
    if (Object.keys(newErrors).length === 0) {
      setLoading2(true);
      writeVisaApi(true);
    }
  };

  // MARK: payload function
  function payload() {
    const createdAt = Timestamp.fromDate(new Date()).toMillis();
    const object = {
      ...visaInfo,
      created_at: createdAt,
      updated_at: null,
    };

    object.visa_type = visaInfo.visa_type.toLowerCase();
    object.country = visaInfo.country.toLowerCase();
    object.applicant_name = visaInfo.applicant_name.toLowerCase();
    object.address = visaInfo.address.toLowerCase();
    object.graduation = visaInfo.graduation.toLowerCase();
    object.other_degree = visaInfo.other_degree.toLowerCase();
    object.selected_visa_refusal = visaInfo.selected_visa_refusal.toLowerCase();
    object.refusal_reason = visaInfo.refusal_reason.toLowerCase();
    object.visa_Processing_time = visaInfo.visa_Processing_time.toLowerCase();
    return object;
  }

  // MARK: reset values function
  function ResetValues() {
    setVisaInfo({
      student_type: null,
      student_firebase_id: null,
      visa_type: "",
      country: "",
      visa_consultant_fee: "",
      visa_Processing_time: "",
      applicant_name: "",
      address: "",
      tenth_marks: "",
      twelfth_marks: "",
      graduation: "",
      other_degree: "",
      selected_course_id: null,
      selected_visa_refusal: "",
      refusal_reason: "",
    });
  }

  // MARK: write API
  async function writeVisaApi(edit) {
    const writePayload = payload();

    if (visaInfo.selected_course_id) {
      writePayload.selected_course_id = visaInfo.selected_course_id?.id;
    }
    writePayload.student_type = visaInfo.student_type.type;
    if (visaInfo.student_firebase_id) {
      writePayload.student_firebase_id =
        visaInfo.student_firebase_id.firebase_id;
    }
    try {
      await addDoc(collection(dbFirestore, TableName.visa), {
        ...writePayload,
      });
      if (edit) {
        toast.success(ToastMessages.visaAdd);
        ResetValues();
        setTimeout(() => {
          setLoading2(false);
          // when user press on save + next
          navigate(RoutingPaths.addVisa);
          ResetValues();
        }, 600);
      } else {
        toast.success(ToastMessages.visaAdd);
        setTimeout(() => {
          setLoading1(false);
          navigate(RoutingPaths.visaList);
        }, 600);
      }
    } catch (error) {
      setLoading1(false); // hide
      const errorMessage = error.message;
      toast.error(errorMessage);
    }
  }

  // MARK: student type API
  async function fetchStudentTypeApi() {
    let q = query(collection(dbFirestore, TableName.studentsType));

    const querySnapshot = await getDocs(q);

    const studentTypeArray = querySnapshot.docs.map((docs) => ({
      ...docs.data(),
    }));

    var typeObject = studentTypeArray.find(function (studentType) {
      return studentType.type === location.state.student_type;
    });
    return typeObject;
  }

  // MARK: regular student API
  async function fetchRegularStudentApi() {
    let q = query(collection(dbFirestore, TableName.students));

    const querySnapshot = await getDocs(q);

    const regularStudentArray = querySnapshot.docs.map((docs) => ({
      ...docs.data(), firebase_id: docs.id,
    }));


    const studentObject = regularStudentArray.find(function (student) {
      return (student.firebase_id === location.state.student_firebase_id)
    });
    return studentObject;
  }

  // MARK: fetch course API
  async function fetchCoursesApi() {
    let q = query(collection(dbFirestore, TableName.courses));

    const querySnapshot = await getDocs(q);
    const arrayCourse = querySnapshot.docs.map((docs) => ({
      ...docs.data(),
    }));

    var courseObject = arrayCourse.find(function (course) {
      return course.id === location.state.selected_course_id;
    });
    return courseObject;
  }

  // MARK: edit data function
  async function setEditVisaUI() {
    const courseObject = await fetchCoursesApi();
    const studentTypeObject = await fetchStudentTypeApi();
    var regularStudentObject;
    if (studentTypeObject.type === "existing_student") {
      regularStudentObject = await fetchRegularStudentApi();
    } else {
      regularStudentObject = null;
    }

    setVisaInfo((prevState) => ({
      ...prevState,
      student_firebase_id: regularStudentObject,
      student_type: studentTypeObject,
      visa_type: location.state.visa_type,
      country: location.state.country,
      visa_consultant_fee: location.state.visa_consultant_fee,
      visa_Processing_time: location.state.visa_Processing_time,
      applicant_name: location.state.applicant_name,
      address: location.state.address,
      tenth_marks: location.state.tenth_marks,
      twelfth_marks: location.state.twelfth_marks,
      graduation: location.state.graduation,
      other_degree: location.state.other_degree,
      selected_course_id: courseObject,
      selected_visa_refusal: location.state.selected_visa_refusal,
      refusal_reason: location.state.refusal_reason,
    }));

    setVisaHeading(CommonHeadings.visaEditHeading);
    setButtonLabel(ButtonLabels.updateLabel);
    setVisaID(location.state.id);
  }

  // MARK: update API
  async function updateVisaInfoApi() {
    const updatedPayload = payload();
    updatedPayload.created_at = location.state.created_at;
    updatedPayload.updated_at = Timestamp.fromDate(new Date()).toMillis();
    if(location.state.selected_course_id) {
      updatedPayload.selected_course_id = visaInfo.selected_course_id?.id
    } else {
      updatedPayload.selected_course_id = null
    }

    updatedPayload.student_type = visaInfo.student_type.type;

    if (visaInfo.student_firebase_id) {
      updatedPayload.student_firebase_id =
        visaInfo.student_firebase_id.firebase_id;
    }

    try {
      await updateDoc(doc(dbFirestore, TableName.visa, visaID), {
        ...updatedPayload,
      });

      toast.success(ToastMessages.visaDeleted);

      setTimeout(() => {
        setLoading1(false);
        navigate(RoutingPaths.visaList);
      }, 600);
    } catch (error) {
      const errorMessage = error.message;
      toast.error(errorMessage);
    }
  }

  // MARK: students list fetch from the firebase
  const studentsTypeList = async (searchText) => {
    const searchName = searchText.toLowerCase()

    let q = query(
      collection(dbFirestore, TableName.studentsType),
      or(
        // query as-is:
        and(
          where("type", ">=", searchName),
          where("type", "<=", searchName + "\uf8ff")
        ),
        and(
          where(
            "type",
            ">=",
            searchName.charAt(0).toUpperCase() + searchName.slice(1)
          ),
          where(
            "type",
            "<=",
            searchName.charAt(0).toUpperCase() + searchName.slice(1) + "\uf8ff"
          )
        )
      )
    );
    const querySnapshot = await getDocs(q);
    const s = querySnapshot.docs.map((docs) => ({
      ...docs.data(),
    }));

    return s;
  };

  // MARK: students name which show in the dropdown
  function studentsType(e) {
    return e["type"];
  }

  // MARK: course list fetch from the firebase
  const courseList = async (searchText) => {
    const searchName = searchText.toLowerCase()

    let q = query(
      collection(dbFirestore, TableName.courses),
      or(
        // query as-is:
        and(
          where("name", ">=", searchName),
          where("name", "<=", searchName + "\uf8ff")
        ),
        and(
          where(
            "name",
            ">=",
            searchName.charAt(0).toUpperCase() + searchName.slice(1)
          ),
          where(
            "name",
            "<=",
            searchName.charAt(0).toUpperCase() + searchName.slice(1) + "\uf8ff"
          )
        )
      )
    );
    const querySnapshot = await getDocs(q);

    const s = querySnapshot.docs.map((docs) => ({
      ...docs.data(),
      id: docs.data().id,
      name: docs.data().name,
    }));

    return s;
  };

  // MARK: course name which show in the dropdown
  function courseName(e) {
    return e["name"];
  }

  // MARK: students list fetch from the firebase
  const regularStudentsList = async (searchText) => {
    const searchName = searchText.toLowerCase()

    let q = query(
      collection(dbFirestore, TableName.students), and(
        where('status', '==', 'active'),   
      or(
        // query as-is:
        and(
          where("name", ">=", searchName),
          where("name", "<=", searchName + "\uf8ff")
        ),
        and(
          where(
            "name",
            ">=",
            searchName.charAt(0).toUpperCase() + searchName.slice(1)
          ),
          where(
            "name",
            "<=",
            searchName.charAt(0).toUpperCase() + searchName.slice(1) + "\uf8ff"
          )
        )
      )
    ));
    const querySnapshot = await getDocs(q);
    const s = querySnapshot.docs.map((docs) => ({
      ...docs.data(),
      firebase_id: docs.id,
    }));

    return s;
  };

  // MARK: students name which show in the dropdown
  function studentsAdmissionNumber(e) {
    return e["name"] + " - " + e["admission_no"];
  }

  return (
    <div className="modules__main__div">
      <div className="col-12">
        <div className="card modules__card">
          <HeadingComponent classname="mb-1 mt-3" headingName={visaHeading} />
          <div className="p-fluid">
            <div className="row modules__row mt-4">
              <div className="col-12 col-md-6">
                <label htmlFor="visa_type" className="input__valid">
                  Visa Type
                </label>
                <Dropdown
                  name="visa_type"
                  value={visaInfo.visa_type}
                  onChange={inputDropVisaType}
                  options={visaTypeDropdown}
                  optionLabel="name"
                  placeholder="Select visa type"
                />
                {isSubmitted && (
                  <small id="visa_type" className="p-error">
                    {errors.visa_type}{" "}
                  </small>
                )}
              </div>

              <div className="col-12 col-md-6">
                <label htmlFor="country" className="input__valid">
                  Choose Country
                </label>
                <InputText
                  name="country"
                  value={visaInfo.country}
                  onChange={inputChange}
                  id="country"
                  type="text"
                  placeholder="Enter country"
                />
                {isSubmitted && (
                  <small id="country" className="p-error">
                    {errors.country}{" "}
                  </small>
                )}
              </div>

              <div className="col-12 col-md-6">
                <label htmlFor="visa_consultant_fee" className="input__valid">
                  {" "}
                  Visa Consultant Fee
                </label>
                <InputText
                  name="visa_consultant_fee"
                  value={visaInfo.visa_consultant_fee}
                  onChange={inputChange}
                  id="visa_consultant_fee"
                  type="text"
                  placeholder="Enter your visa fee"
                />
                {isSubmitted && (
                  <small id="visa_consultant_fee" className="p-error">
                    {errors.visa_consultant_fee}{" "}
                  </small>
                )}
              </div>

              <div className="col-12 col-md-6">
                <label htmlFor="visa_Processing_time" className="input__valid">
                  {" "}
                  Visa Process Timing
                </label>
                <InputText
                  name="visa_Processing_time"
                  value={visaInfo.visa_Processing_time}
                  onChange={inputChange}
                  id="visa_Processing_time"
                  type="text"
                  placeholder="Enter visa process timing"
                />
                {isSubmitted && (
                  <small id="visa_Processing_time" className="p-error">
                    {errors.visa_Processing_time}{" "}
                  </small>
                )}
              </div>
            </div>
            <HeadingComponent
              classname="mb-3 mt-5"
              headingName="Personal Information"
            />
            <div className="row modules__row">
              <div className="col-12 col-md-6">
                <label htmlFor="student_type" className="input__valid">
                  Student Type
                </label>
                <AsyncSelect
                  classNamePrefix="batch__dropdown"
                  isClearable
                  cacheOptions
                  loadOptions={studentsTypeList}
                  value={visaInfo.student_type}
                  defaultOptions
                  getOptionLabel={(e) => studentsType(e)}
                  getOptionValue={(e) => e}
                  onChange={studentsTypeSelect}
                />
                {isSubmitted && (
                  <small id="student_type" className="p-error">
                    {errors.student_type}{" "}
                  </small>
                )}
              </div>

              {visaInfo.student_type?.type === "existing_student" && (
                <div className="col-12 col-md-6">
                  <label htmlFor="student_firebase_id" className="input__valid">
                    Select Student
                  </label>
                  <AsyncSelect
                    isClearable
                    cacheOptions
                    loadOptions={regularStudentsList}
                    value={visaInfo.student_firebase_id}
                    defaultOptions
                    getOptionLabel={(e) => studentsAdmissionNumber(e)}
                    getOptionValue={(e) => e}
                    onChange={studentsAdmissionSelect}
                  />
                  {isSubmitted && (
                    <small id="student_firebase_id" className="p-error">
                      {errors.student_firebase_id}{" "}
                    </small>
                  )}
                </div>
              )}

              <div className="col-12 col-md-6">
                <label htmlFor="applicant_name" className="input__valid">
                  {" "}
                  Name
                </label>
                <InputText
                  name="applicant_name"
                  value={visaInfo.applicant_name}
                  onChange={inputChange}
                  id="applicant_name"
                  type="text"
                  placeholder="Enter your name"
                />
                {isSubmitted && (
                  <small id="applicant_name" className="p-error">
                    {errors.applicant_name}{" "}
                  </small>
                )}
              </div>

              <div className="col-12 col-md-6">
                <label htmlFor="tenth_marks"> 10th Marks</label>
                <InputText
                  name="tenth_marks"
                  value={visaInfo.tenth_marks}
                  onChange={inputChange}
                  id="tenth_marks"
                  type="text"
                  placeholder="Enter your 10th marks"
                />
              </div>

              <div className="col-12 col-md-6">
                <label htmlFor="twelfth_marks"> 12th Marks</label>
                <InputText
                  name="twelfth_marks"
                  value={visaInfo.twelfth_marks}
                  onChange={inputChange}
                  id="twelfth_marks"
                  type="text"
                  placeholder="Enter your 12th marks"
                />
              </div>

              <div className="col-12 col-md-6">
                <label htmlFor="graduation">Graduation</label>
                <InputText
                  name="graduation"
                  value={visaInfo.graduation}
                  onChange={inputChange}
                  id="graduation"
                  type="text"
                  placeholder="Enter your graduation info"
                />
              </div>

              <div className="col-12 col-md-6">
                <label htmlFor="other_degree">Other Degree</label>
                <InputText
                  name="other_degree"
                  value={visaInfo.other_degree}
                  onChange={inputChange}
                  id="other_degree"
                  type="text"
                  placeholder="Enter other degree info"
                />
              </div>

              <div className="col-12 col-md-6">
                <label htmlFor="selected_course_id">Course</label>
                <AsyncSelect
                  classNamePrefix="course__dropdown"
                  maxMenuHeight={170}
                  isClearable
                  cacheOptions
                  loadOptions={courseList}
                  value={visaInfo.selected_course_id}
                  defaultOptions
                  getOptionLabel={(e) => courseName(e)}
                  getOptionValue={(e) => e}
                  onChange={courseSelect}
                />
              </div>

              <div className="col-12 col-md-6">
                <label htmlFor="selected_visa_refusal">
                  Previous Visa Refusal
                </label>
                <Dropdown
                  name="selected_visa_refusal"
                  value={visaInfo.selected_visa_refusal}
                  onChange={inputDropVisaRefusal}
                  options={visaRefusalDropdown}
                  optionLabel="name"
                  placeholder="Select refusal option "
                />
              </div>

              {visaInfo.selected_visa_refusal === VisaRefusalKeys.key1 && (
                <div className="col-12 col-md-6">
                  <label htmlFor="refusal_reason">Description</label>
                  <InputTextarea
                    name="refusal_reason"
                    value={visaInfo.refusal_reason}
                    onChange={inputChange}
                    id="refusal_reason"
                    placeholder="Enter refusal reason"
                    rows={3}
                    cols={30}
                  />
                </div>
              )}

              <div className="col-12 col-md-6">
                <label htmlFor="address" className="input__valid">
                  Address
                </label>
                <InputTextarea
                  name="address"
                  value={visaInfo.address}
                  onChange={inputChange}
                  id="address"
                  placeholder="Enter your address"
                  rows={3}
                  cols={30}
                />
                {isSubmitted && (
                  <small id="address" className="p-error">
                    {errors.address}{" "}
                  </small>
                )}
              </div>
            </div>
          </div>
          <div className="flex mt-3">
            <BottomButtons
              label={buttonLabel}
              save={tapOnSave}
              loading1={loading1}
              saveNext={tapOnSaveNext}
              loading2={loading2}
            />
            <ToastContainer />
          </div>
        </div>
      </div>
    </div>
  );
}

export default Visa;
